import { Injectable, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { EventLogService } from 'src/app/shared/logging/event-log.service';

type ActivitySection =
  | 'dashboard'
  | 'checklist'
  | 'despacho_actual'
  | 'historial'
  | 'fatiga'
  | 'combustible';

const SECTION_ACTION: Record<ActivitySection, string> = {
  dashboard: 'entrada_dashboard',
  checklist: 'entrada_checklist',
  despacho_actual: 'entrada_despacho_actual',
  historial: 'entrada_historial',
  fatiga: 'entrada_fatiga',
  combustible: 'entrada_combustible',
};

function resolveActivitySection(url: string): ActivitySection | null {
  const path = url.split('?')[0].toLowerCase();

  if (path.includes('pedidospendiente')) {
    return 'despacho_actual';
  }
  if (path.includes('checklist')) {
    return 'checklist';
  }
  if (path.includes('fatiga')) {
    return 'fatiga';
  }
  if (path.includes('pedidosentregados')) {
    return 'historial';
  }
  if (path.includes('dashboard')) {
    return 'dashboard';
  }
  if (path.includes('controlcombustible')) {
    return 'combustible';
  }

  return null;
}

@Injectable({ providedIn: 'root' })
export class ActivityLogService implements OnDestroy {
  private sub: Subscription | null = null;
  private started = false;
  private lastSection: ActivitySection | null = null;

  constructor(
    private readonly router: Router,
    private readonly eventLog: EventLogService
  ) {}

  init(): void {
    if (this.started) {
      return;
    }
    this.started = true;

    this.logIfSection(this.router.url);

    this.sub = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => this.logIfSection(event.urlAfterRedirects));
  }

  private logIfSection(url: string): void {
    const section = resolveActivitySection(url);
    if (!section) {
      this.lastSection = null;
      return;
    }
    if (section === this.lastSection) {
      return;
    }

    this.lastSection = section;
    this.eventLog.log('actividad', SECTION_ACTION[section], {
      seccion: section,
      ruta: url.split('?')[0],
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
